(function() {
  'use strict';

  angular.module('widgets.files', []);
})();
